export const USERS = {
  SHOW_DASHBOARD: 'show_dashboard',
  FETCH_USERS: 'fetch_users',
  ADD_USERS: 'add_users'
}
export const CHAT = {
  SET_LOGIN_INDEX: 'set_login_index',
  SET_ACTIVE_CHAT: 'set_active_chat',
  FETCH_ACTIVE_CHAT: 'fetch_active_chat',
  ADD_CHAT: 'add_chat'
}